import Vue from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue';
import VueCompositionAPI from '@vue/composition-api';
import VueFormulate from '@braid/vue-formulate';
import VueRouter from 'vue-router';
import VueFormulatePlugins from '@/lego/plugins/vue-formulate';
import { ZiggyVue } from 'ziggyVue';
import Hover from '@/directives/hover';
import SvgVue from '@/lego/components/icons/SvgIcon.vue';
import boot from '@/lego/config/boot';
import { router } from '@/lego/config/router';

// Para usar con <Transition />
import 'animate.css';
import { Inertia } from '@inertiajs/inertia';

Vue.component('svg-vue', SvgVue);
Vue.use(VueCompositionAPI);
Vue.use(VueRouter);
Vue.use(VueFormulate, { plugins: VueFormulatePlugins });
Vue.use(ZiggyVue);

Vue.directive('hover', Hover);

createInertiaApp({
  resolve: name => import(`./lego/${name}.vue`),
  setup({ el, App, props, plugin }) {
    Vue.use(plugin);

    const app = new Vue({
      render: h => h(App, props),
      router: router,
    });

    boot(app);

    app.$mount(el);
  },
});

// Gtag?

export const inertiaReload = event => {
  event.stopImmediatePropagation();

  try {
    Inertia.reload({
      preserveState: true,
      preserveScroll: false,
      replace: true,
      onFinish: () => {
        if (router.currentRoute.fullPath !== event.state.url) {
          router.replace(event.state.url);
        }
      },
    });
  } catch (e) {
    // TODO: en la navegación del flujo de docu hay un error que no afecta al funcionamiento, pero se debe corregir eventualmente
  }
};

window.addEventListener('popstate', inertiaReload);
